export const BASE_URI_PROGRESS = '/academy/learning-center/progress/v1';